import React, { useState, useMemo, useCallback, useContext, useEffect } from "react";
import { DownOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Button, Col, Container, Row, Card, CardBody, CardHeader,  } from "reactstrap";
import TableContainerMin from "../../../../common/TableContainerMin";
import { useQuery, useQueryClient } from "react-query";
import { Spin,Modal, Skeleton, Dropdown } from "antd";
import toast from "react-hot-toast";
import AddEditDevForm from "../component/addEditDevForm.js";
import CompleteCompanymerchent from "../../../company/component/completeCompany";
import '../utils/style.css';
import DeleteModalOTP from "../../../../common/delete/modalDeleteOtp.js";
import DetailBusiness from "../component/detailMerchent.js";
import { createEspaceClient, deleteMerchent, getAllMerchent, getBusinessMarchandById, getMerchantInactif, getMerchantTOPRevenu, getMerchantTotalRevenu, searchMerchantByBusinessName } from "../services/merchentApi.js";
import ManageMerchent from "../component/manageMerchant.js";
import vectorIcon from "../../../../assets/images/menu-alt-2.png";
import vector from "../../../../assets/images/Vector.png";
import defaultAvatar from "../../../../assets/images/default-avatar.png";
import { useNavigate } from "react-router-dom";
import filter from "../../../../assets/images/cuida_filter-outline.png";
import inactif from "../../../../assets/images/inactif.png";
import semaine from "../../../../assets/images/semaine.png";
import rentable from "../../../../assets/images/rentable.png";
import percentage from "../../../../assets/images/percentage.png";
import trier from "../../../../assets/images/mdi_sort.png";
import FiltrerMerchentModal from "../component/FiltrerMerchentModal .js";
import TrierMerchentModal from "../component/TrierMerchentModal.js";
import empty from "../../../../assets/images/emptyMarchand.png";
import CardItem from "../../dashboard/component/cardItem.js";
import { getAverageMonthlyVolume, getStatsByMerchantId } from "../../dashboard/services/homeAdminApi.js";
import dollardIcon from "../../../../assets/images/violet.png";
import { getMetricsByBusIdPercountryCode } from "../../../developer/services/developerApi.js";
import { getAllDevelopers } from "../../business/services/developerApi.js";
import twoRow from "../../../../assets/images/jaune.png";
import rowDown from "../../../../assets/images/vert.png";
import CardItemS from "../../dashboard/component/cardItemS.js";
import { saveUserToSessionStorage } from "../../../auth/services/authApi.js";
import { DeleteOutlined, LoginOutlined } from "@ant-design/icons";
import { setAuthorization } from "../../../../helpers/api_helper.js";
import KycMerchent from "../component/rappelValidate.js";
import countryFlagEmoji from "country-flag-emoji"; 
import CreateNewMerchentModal from "../component/CreateNewMerchentModal.js";
import DeleteModal from "../../../../common/delete/modalDelete.js";
import { FormatCurrency } from "../../../../common/format/formatCurrency.js";
import PaginationCustom from "../component/paginationCustom.js";
const Merchent = () => {
    const [selectedMarchand, setSelectedMarchand] = useState(null);
    const [selectedCountryCode, setSelectedCountryCode] = useState("");
    const [selectedBusiness, setSelectedBusiness] = useState(null);
    const { data: stats } = useQuery("stats", getAverageMonthlyVolume);
    const { isLoadingD, isErrorD, errorD, data: developers } = useQuery("developers", getAllDevelopers)
    const busId = selectedBusiness?.id;
    const cc = selectedCountryCode;
   const { data: metrics, isLoading: isLoadingMetric, isError: isErrorMetric, error: errorMetric } = useQuery(
       ["metrics", busId, cc],
       () => getMetricsByBusIdPercountryCode(busId, cc),
       { enabled: !!busId && !!cc }
     );
     const { countryBalance } = metrics || {};
    const { data: statsMerchant, isLoading: isLoadingMerchantStats } = useQuery(
       ["merchantStats", selectedMarchand],
       () => getStatsByMerchantId(selectedMarchand),
       {
         enabled: !!selectedMarchand,
       }
     );
   const { isLoading, isError, error, data: merchants } = useQuery(
  "merchants",
  getAllMerchent
);
   const marchandsActifs = Array.isArray(merchants)
  ? merchants.filter((m) => m.active === true).length
  : 0;
  const activeMerchants = selectedMarchand ? statsMerchant?.activeMerchants : marchandsActifs;
    const pourcentageMActif = selectedMarchand
    ? ((statsMerchant?.activeMerchants*100)/marchandsActifs).toFixed(0)
    : merchants?.length
      ? ((marchandsActifs * 100) / merchants.length).toFixed(0)
      : 0;
      const { 
  data: merchantBusiness,
  isLoading: isLoadingMerchantBusiness,
  isError: isErrorMerchantBusiness
} = useQuery(
  ["merchantBusiness", selectedMarchand],
  () => getBusinessMarchandById(selectedMarchand),
  {
    enabled: !!selectedMarchand
  }
);

    const activeBusinesses = selectedMarchand ? statsMerchant?.activeDeveloperAccounts : stats?.activeDeveloperAccounts;
    const pourcentageActifBusiness = selectedMarchand
    ? ((statsMerchant?.activeDeveloperAccounts*100)/merchantBusiness?.length).toFixed(0)
    : developers?.length
    ? ((stats?.activeDeveloperAccounts * 100) / developers.length).toFixed(0)
    : 0;

const { data: totalRevenu, isLoading: loadingTotalRevenu } = useQuery(
  "totalRevenue",
  getMerchantTotalRevenu
);
const navigate = useNavigate();
 const [searchTerm, setSearchTerm] = useState("");
const [filterValues, setFilterValues] = useState(null);
const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
const [isModalOpen, setIsModalOpen] = useState(false);
 const [isModalOpenNewMerchant, setIsModalOpenNewMerchent] = useState(false);
const [selectedMerchant, setSelectedMerchant] = useState(null);
const queryClient = useQueryClient();
document.title = `Business | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;
const [modalState, setModalState] = useState({ type: null, data: null });
const [isDeleting, setIsDeleting] = useState(false);
const currentuser = JSON.parse(sessionStorage.getItem('authAdmin'));

const tabs = ['Tous', 'Actives', 'En cours', 'Désactivés', 'Rejetés'];
const [activeTab, setActiveTab] = useState('Tous');
const [sortOrder, setSortOrder] = useState("asc");
 const handleApplyFilters = (filters) => {
  setFilterValues(filters);
};
const handleTabChange = (tab) => {
    setActiveTab(tab);
  };
 const [debouncedSearch, setDebouncedSearch] = useState("");

useEffect(() => {
  const t = setTimeout(() => {
    setDebouncedSearch(searchTerm);
  }, 400);

  return () => clearTimeout(t);
}, [searchTerm]);
const [searchedMerchants, setSearchedMerchants] = useState([]);

useEffect(() => {
  const fetchSearch = async () => {
    // si vide => afficher tous les marchands
    if (!debouncedSearch.trim()) {
      setSearchedMerchants(merchants || []);
      return;
    }

    try {
      // Recherche API par business
      const businessResults = await searchMerchantByBusinessName(debouncedSearch);

      // Recherche locale par nom/prénom marchand
      const merchantResults = (merchants || []).filter((merchant) => {
        const fullName =
          `${merchant.firstName || ""} ${merchant.lastName || ""}`.toLowerCase();

        return fullName.includes(debouncedSearch.toLowerCase());
      });

      // Fusion sans doublons
      const mergedResults = [...businessResults];

      merchantResults.forEach((merchant) => {
        const exists = mergedResults.find((m) => m.id === merchant.id);

        if (!exists) {
          mergedResults.push(merchant);
        }
      });

      setSearchedMerchants(mergedResults);

    } catch (error) {
      console.error("Erreur recherche :", error);
      setSearchedMerchants([]);
    }
  };

  fetchSearch();
}, [debouncedSearch, merchants]);
const baseData = useMemo(() => {
  return searchedMerchants || [];
}, [searchedMerchants]);
 const filteredMerchents = useMemo(() => {
  if (!baseData || baseData.length === 0) return [];

  let result = [...baseData];

  // filtres
  if (filterValues) {
    if (filterValues.active !== "") {
      result = result.filter((t) => t.active === filterValues.active);
    }

    if (filterValues.kycStatus !== "") {
      result = result.filter((t) => t.kycStatus === filterValues.kycStatus);
    }
    if (filterValues.kycVerified !== "") {
      result = result.filter((t) => t.kycVerified === filterValues.kycVerified);
    }
    if (filterValues?.minBalance !== "" || filterValues?.maxBalance !== "") {
  result = result.filter((merchant) => {
    const balance = Number(merchant.totalRevenue || 0);

    const min =
      filterValues.minBalance !== ""
        ? Number(filterValues.minBalance)
        : 0;

    const max =
      filterValues.maxBalance !== ""
        ? Number(filterValues.maxBalance)
        : Number.MAX_SAFE_INTEGER;

    return balance >= min && balance <= max;
  });
}
    if (filterValues.countrie) {
      result = result.filter((t) => t.country === filterValues.countrie);
    }

    if (filterValues.createdDate) {
      result = result.filter((t) => {
        const txDate = new Date(t.createdDate).toISOString().slice(0, 10);
        return txDate === filterValues.createdDate;
      });
    }
  }

  // tri
  if (sortOrder === "asc") {
    result.sort((a, b) => new Date(a.createdDate) - new Date(b.createdDate));
  } else {
    result.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
  }

  return result;
}, [baseData, filterValues, sortOrder]);
  const openModal = (type, data = null) => {
    setModalState((prevState) => (prevState.type === type ? { type: null, data: null } : { type, data }));
  };
  const handleEdit = (merchent) => {
    openModal("edit", merchent);
  };
  const handleDetail = (merchent) => {
  navigate(`/marchands/${merchent.id}`);
};
  const handleValidate = (merchent) => {
    openModal("valid", merchent);
  };
  const handleRappel = (action, merchant) => {
  setModalState({
    type: "rappel",
    action,       
    data: merchant 
  });
};
  const openDeleteConfirmModal = (merchentId) => {
    const merchentToDelete = merchants.find(merchent => merchent.id === merchentId);
    if (merchentToDelete) {
      setModalState({
        type: "delete",
        data: { merchentId, merchentName: `${merchentToDelete.firstName} ${merchentToDelete.lastName}` },
      });
    }
  };
  const closeDeleteConfirmModal = () => {
    setModalState({ type: null, data: null });
  };

  const handleDelete = async (merchentId) => {
    setIsDeleting(true);
    try {
      await deleteMerchent(merchentId);
      queryClient.invalidateQueries("merchants");
      toast.success("Le business a été supprimé avec succès");
    } catch (error) {
      toast.error(`😔 Erreur lors de la suppression du business : ${error?.message || error}`);
    } finally {
      setIsDeleting(false);
      closeDeleteConfirmModal();
    }
  };
const [isMobile, setIsMobile] = useState(false);
useEffect(() => {
  const handleResize = () => setIsMobile(window.innerWidth <= 768);
  handleResize(); // Vérifie dès le chargement
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);
const countryFlags = {
  "221": "https://flagcdn.com/w40/sn.png",
  "225": "https://flagcdn.com/w40/ci.png", 
  "226": "https://flagcdn.com/w40/bf.png", 
  "229": "https://flagcdn.com/w40/bj.png", 
  "227": "https://flagcdn.com/w40/ne.png", 
  "223": "https://flagcdn.com/w40/ml.png",
  "224": "https://flagcdn.com/w40/gn.png", 
  "228": "https://flagcdn.com/w40/tg.png", 
  "237": "https://flagcdn.com/w40/cm.png",
  "243": "https://flagcdn.com/w40/cd.png", 
  "254": "https://flagcdn.com/w40/ke.png", 
  "234": "https://flagcdn.com/w40/ng.png",
  "233": "https://flagcdn.com/w40/gh.png", 
};
const getFlagFromPhone = (phoneNumber) => {
  if (!phoneNumber) return "🏳️";
  const digits = phoneNumber.replace(/\D/g, "");
  const matchedCode = Object.keys(countryFlags).find(code => digits.startsWith(code));
  return matchedCode ? countryFlags[matchedCode] : "🏳️";
};
const formatSenegalPhoneNumber = (number) => {
  if (!number) return "";
  const digits = number.replace(/\D/g, "");
  if (digits.length === 8) {
    return digits.replace(/(\d{2})(\d{3})(\d{2})(\d{2})/, "$1 $2 $3 $4");
  }
  if (digits.startsWith("221") && digits.length === 11) {
    const local = digits.slice(3); 
    return local.replace(/(\d{2})(\d{3})(\d{2})(\d{2})/, "$1 $2 $3 $4");
  }
  return number;
};
  const columns = useMemo(() => [
   {
  Header: "Nom complet",
  accessor: "lastName",
  filterable: false,
  Cell: ({ row }) => {
    const { firstName, lastName, profilePhoto } = row.original;
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <img
          src={profilePhoto || defaultAvatar}
          alt=''
          style={{
            width: 29,
            height: 29,
            borderRadius: "50%",
            objectFit: "cover"
          }}
        />
        <span>{firstName} {lastName}</span>
      </div>
    );
  }
},
{
  Header: "N° Téléphone",
  accessor: "phoneNumber",
  Cell: ({ row }) => {
    const { phoneNumber } = row.original;
    const flag = getFlagFromPhone(phoneNumber);

    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        {flag.startsWith("http") ? (
          <img src={flag} alt="flag" style={{ width: 20, height: 14 }} />
        ) : (
          <span>{flag}</span>
        )}
        <span>{formatSenegalPhoneNumber(phoneNumber)}</span>
      </div>
    );
  },
  filterable: false,
},
{
  Header: "Date création",
  accessor: "createdDate",
  Cell: ({ value }) =>
    value
      ? new Date(value).toLocaleString("fr-FR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })
      : "-",
  filterable: false,
},
    {
    Header: "Identifications",
    accessor: "kycVerified",
    Cell: ({ value }) => {
      let label = "Non défini";
      let style = {
        backgroundColor: "#FFEFD5", 
        color: "#000",
        padding: "1px 6px",
        borderRadius: "100px",
        fontWeight: 400,
        fontSize: "13px",
        fontStyle: 'Medium'
      };
        let icon = "❓";
      if (value === true) {
        label = "KYC ACTIVÉ";
         icon = "✓";
        style.backgroundColor = "#EBFFEA"; 
        style.color = "#349C32";           
      } else if (value === false) {
        label = "KYC DÉSACTIVÉ";
         icon = "🚫"; 
        style.backgroundColor = "#FFF0F0";
        style.color = "#D41C1C";
      }

      return (
      <span style={style}>
        <span>{icon}</span> {label}
      </span>
    );
    },
    filterable: false,
    }, 
   {
  Header: "Suivi des demandes KYC",
  accessor: "kycStatus",
  Cell: ({ value }) => {
      let label = "Non défini";
      let style = {
        backgroundColor: "#FFEFD5",
        color: "#000",
        padding: "1px 6px",
        borderRadius: "100px",
        fontWeight: 400,
        fontSize: "13px",
        fontStyle: 'Medium'
      };
    let icon = "❓";

    if (value === "APPROVED") {
      label = "KYC APPROUVÉ";
      icon = "✓";
      style.backgroundColor = "#EBFFEA"; 
      style.color = "#349C32";           
    } else if (value === "SUBMITTED") {
      label = "KYC EN ATTENTE";
      icon = "⏳";
      style.backgroundColor = "#FFF8DC"; 
      style.color = "#FF7F29";           
    } else if (value === "REJECTED") {
      label = "KYC REJETÉ";
      icon = "🚫";
      style.backgroundColor = "#FFF0F0"; 
      style.color = "#D41C1C";           
    } else if (value === "NOT_SUBMITTED") {   
      label = "NON SOUMIS";
      icon = "🌀";
      style.backgroundColor = "#396AFC14";
      style.color = "#396AFC";
    }

    return (
      <span style={style}>
        <span>{icon}</span> {label}
      </span>
    );
  },
  filterable: false,
}, 
    {
     Header: () => (
    <div style={{ textAlign: "right", width: "100%" }}>
      Action
    </div>
  ),
  accessor: "action",
      Cell: ({ row }) => {
        return (
          
           <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: "24px",
                height: "24px",
                backgroundColor: "#FFFFFF",
                borderRadius: "50%",
                cursor: "pointer",
                border: "1px solid #00000014",
              }}
            onClick={(e) => {
          e.stopPropagation();
          setSelectedMerchant(row.original); 
          const rect = e.currentTarget.getBoundingClientRect();
              setModalPosition({
              top: rect.bottom + window.scrollY,
              left: rect.left + window.scrollX -250,
            });
          setIsModalOpen(true);
        }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="6" cy="12" r="2" fill="#21272A" />
                <circle cx="12" cy="12" r="2" fill="#21272A" />
                <circle cx="18" cy="12" r="2" fill="#21272A" />
              </svg>
            </div>
          </div>
        );
      },
      filterable: false,
    },
  ], [handleEdit, openDeleteConfirmModal, handleDetail, handleValidate, handleRappel]);

  const renderTabs = () => (
    <div className="d-flex gap-3 mb-3">
      {tabs.map((tab) => (
        <Button
          key={tab}
          onClick={() => handleTabChange(tab)}
          className={`btn ${activeTab === tab ? 'active-tab' : 'btn-light'}`}
        >
          {tab}
        </Button>
      ))}
    </div>
  );
  //pagination des marchands inactifs
  const [page, setPage] = useState(1);
const size = 4; 
const [totalPages, setTotalPages] = useState(0);

const pagination = useMemo(() => ({
  pageIndex: page - 1,
  canPreviousPage: page > 1,
  canNextPage: page < totalPages,
  gotoPage: (i) => setPage(i + 1),
  previousPage: () => setPage((p) => Math.max(p - 1, 1)),
  nextPage: () => setPage((p) => Math.min(p + 1, totalPages)),
}), [page, totalPages])
  const [topMerchants, setTopMerchants] = useState([]);
  const [inactifMerchants, setInactifMerchants] = useState([]);
const [loadingTop, setLoadingTop] = useState(false);
const [loadingInactif, setLoadingInactif] = useState(false);
useEffect(() => {
  const fetchTopMerchants = async () => {
    try {
      setLoadingTop(true);
      const res = await getMerchantTOPRevenu();
      setTopMerchants(res?.content ||  []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingTop(false);
    }
  };
  fetchTopMerchants();
}, []);
useEffect(() => {
  const fetchInactifMerchants = async () => {
    try {
      setLoadingInactif(true);

      const res = await getMerchantInactif(page - 1, size);

      setInactifMerchants(res?.content || []);
      setTotalPages(res?.totalPages || 0);

    } catch (error) {
      console.error(error);
    } finally {
      setLoadingInactif(false);
    }
  };

  fetchInactifMerchants();
}, [page, size]);
//7jours derniers
const [newPage, setNewPage] = useState(1);


const sevenDaysAgo = new Date();
sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

const newMerchants = useMemo(() => {
  if (!Array.isArray(merchants)) return [];

  return merchants.filter((m) => {
    if (!m.createdDate) return false;
    return new Date(m.createdDate) >= sevenDaysAgo;
  });
}, [merchants]);

/* 2. PAGINATION */
const paginatedNewMerchants = useMemo(() => {
  const start = (newPage - 1) * size;
  const end = start + size;
  return newMerchants.slice(start, end);
}, [newMerchants, newPage]);
const exportToPDF = () => {
  const doc = new jsPDF();
  const tableColumn = [
    "Nom",
    "Téléphone",
    "Email",
    "Status",
    "KYC",
    "Suivi KYC",
    "Date",
    "chiffre d'affaire"
  ];
  const tableRows = filteredMerchents.map((m) => [
    `${m.firstName} ${m.lastName}`,
    m.phoneNumber,
    m.email || "-",
    m.active ? "Actif" : "Inactif",
    m.kycVerified ? "KYC ACTIVÉ" : "KYC DÉSACTIVÉ",
    m.kycStatus || "-",
    m.totalRevenue|| "0",
    new Date(m.createdDate).toLocaleDateString("fr-FR"),
  ]);

  doc.text("Liste des marchands", 14, 15);
  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,
    startY: 20,
  });

  doc.save("marchands.pdf");
};
const exportToExcel = () => {
  const data = filteredMerchents.map((m) => (
{
  "Nom": `${m.firstName} ${m.lastName}`,
  "Téléphone": m.phoneNumber,
  "Email": m.email,
  "Statut": m.active ? "Actif" : "Inactif",
  "Identifications": m.kycVerified ? "KYC ACTIVÉ" : "KYC DÉSACTIVÉ",
  "Suivi des demandes KYC": m.kycStatus,
  "Chiffre d'affaires": m.totalRevenue|| "0",
  "Date de création": m.createdDate,
}));

  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(wb, ws, "Marchands");
  XLSX.writeFile(wb, "marchands.xlsx");
};
//export top 10 montant comprise entre 0 et 5000

const exportMenu = [
  {
    key: "excel",
    label: "Exporter Excel",
    onClick: exportToExcel,
  },
  {
    key: "pdf",
    label: "Exporter PDF",
    onClick: exportToPDF,
  },
];
  const HeaderTable = ({pageIndex,
  totalPages,
  canPreviousPage,
  canNextPage,
  previousPage,
  nextPage,
  gotoPage}) => (  
  <div className="d-flex flex-column align-items-start gap-3 w-100">
    <div className='title-page mb-2'>
      Marchands
      <span className="lenght">
            {isLoading ? (
              <Spin size="small" />
            ) : !merchants?.length ? (
              "0"
            ) : (
              merchants.length
            )}
      </span>
    </div>
    <div style={{ backgroundColor: '#FBFBFB', padding: '10px',width: '100%',
    minHeight: '180px', 
    boxSizing: 'border-box'}} className="mb-3">
        <Row className="g-3 ">
        <Col xs={12} sm={6} lg={4} className="mb-4">
          <CardItem
            title="Marchands actifs"
            pourcentage={pourcentageMActif}
            titles={`+${pourcentageMActif}%`}
             badgeColor="#E5E4FF" 
             color="#8280FF"
            icon={dollardIcon}
            counterEnd={activeMerchants}
            currency={countryBalance?.currency}
            isLoading={isLoadingMerchantStats || isLoadingMetric}
          isError={isErrorMetric}
          />
        </Col>
        <Col  xs={12} sm={6} lg={4} className="mb-3">
          <CardItem
            title="Business actifs"
            pourcentage={pourcentageActifBusiness}
            titles={`+${pourcentageActifBusiness}%`}
            badgeColor="#FFF3D6" 
            color="#E8AC1E"
            icon={twoRow}
            counterEnd={activeBusinesses}
            currency={(countryBalance?.currency)}
          isLoading={isLoadingMerchantStats || isLoadingMetric}
          isError={isErrorMetric}
          />
        </Col>
        <Col  xs={12} sm={6} lg={4} className="mb-3">
          <CardItemS
            title="Total chiffre d’affaires"
            icon={rowDown}
            counterEnd={
              loadingTotalRevenu
                ? "Chargement..."
                : totalRevenu?.totalRevenue
            }
            currency={totalRevenu?.currency}
            isLoading={ loadingTotalRevenu}
            isError={isErrorMetric}
          />
        </Col>
      </Row>
    </div>
 
  {/* CARD 1 */}
   <div style={{ backgroundColor: '#FBFBFB', padding: '10px',width: '100%',
    minHeight: '180px', 
    boxSizing: 'border-box'}} className="mb-3">
  <Row className="g-3">
  <Col xs={12} md={6} className="">
    <Card
      className="card-animate w-100 h-100"
      style={{
         borderRadius: "10px",background:"#FFFFFF",border:'none',
      }}
    >
    <CardBody className="d-flex flex-column">
  <div className="d-flex justify-content-between align-items-center">
  <div className="title-top">
    Top 10 marchands les plus rentables
  </div>
</div>
  {loadingTop ? (
    <div style={{ textAlign: "center", marginTop: "20px" }}>
      <Spin/>
    </div>
  ) : (
    topMerchants.map((merchant, index) => (
      <div
        key={merchant.id || index}
        className="d-flex justify-content-between align-items-center mt-2">
        <div className="d-flex align-items-start gap-2">
          <span className="rank-circle">{index + 1}</span>
          <div className="d-flex flex-column">
            <span className="title-name-merchend">
              {merchant.fullName}
            </span>
            <span className="title-number-business">
              {(merchant.totalTransactions?.toLocaleString()  || 0)} transactions • {merchant.numberOfBusinesses || 0} business
            </span>
          </div>
        </div>
        <div className="revenu-merchend">
          {FormatCurrency(merchant.totalRevenue || 0)}
        </div>
      </div>
    ))
  )}
</CardBody>
</Card>
  </Col>
  <Col xs={12} md={6} className="d-flex flex-column gap-3">
    <Card
      className="card-animate w-100"
       style={{
         borderRadius: "10px",background:"#FFFFFF",border:'none',
      }}
    >
     <CardBody className="d-flex flex-column">
        <div className="d-flex justify-content-between align-items-center">
          <div  className="title-top">
            Nouveaux inscrits (7 derniers jours)
          </div>
          <div style={{ fontWeight:'400',fontSize:"15px",fontFamily:"Poppins",color:"#000000CC" }}>
             <img src={semaine} alt="Filtrer" width={20} />
          </div>
        </div>
      {paginatedNewMerchants.map((merchant) => (
  <div
    key={merchant.id}
    className="d-flex justify-content-between align-items-center mt-2"
  >
    <div className="d-flex align-items-start gap-2">
      <div className="avatar-circle">
        {merchant.firstName?.[0]}{merchant.lastName?.[0]}
      </div>

      <div className="d-flex flex-column">
        <span className="title-name-merchend">
          {merchant.firstName} {merchant.lastName}
        </span>

        <span className="title-number-business">
          {merchant.email || merchant.phoneNumber}
        </span>
      </div>
    </div>

    {/* RIGHT */}
    <div className="title-number-business">
      {new Date(merchant.createdDate).toLocaleDateString("fr-FR")}

      <div className="percentage d-flex align-items-center gap-1">
         <span
                style={{
                  backgroundColor: merchant.active ? "#EBFFEA" : "#FFEFD5",
                  color: merchant.active ? "#349C32" : "#FF7F29",
                  padding: "3px 12px",
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  fontSize: "14px",
                  borderRadius: "999px",
                }}
              >
                 {merchant.active ? "Activé" : "désactivé"}
              </span>
      </div>
    </div>
  </div>
))}
  <PaginationCustom
    pageIndex={newPage - 1}
    totalPages={Math.ceil(newMerchants.length / size)}
    canPreviousPage={newPage > 1}
    canNextPage={newPage < Math.ceil(newMerchants.length / size)}
    previousPage={() => setNewPage((p) => Math.max(p - 1, 1))}
    nextPage={() =>
      setNewPage((p) =>
        Math.min(p + 1, Math.ceil(newMerchants.length / size))
      )
    }
    gotoPage={(i) => setNewPage(i + 1)}
  />
</CardBody>
    </Card>
    <Card
      className="card-animate w-100"
       style={{
         borderRadius: "10px",background:"#FFFFFF",border:'none',
      }}
    >
       <CardBody className="d-flex flex-column">
        <div className="d-flex justify-content-between align-items-center">
          <div  className="title-top">
           Marchands inactifs
          </div>
          <div style={{ fontWeight:'400',fontSize:"15px",fontFamily:"Poppins",color:"#000000CC" }}>
             <img src={inactif} alt="Filtrer" width={20} />
          </div>
        </div>
         {loadingInactif ? (
    <div style={{ textAlign: "center", marginTop: "20px" }}>
      <Spin/>
    </div>
  ) : (
    inactifMerchants.map((merchand, index) => (
        <div key={merchand.id || index} className="d-flex justify-content-between align-items-center mt-2">
         <div className="d-flex align-items-start gap-2">
         <div className="avatar-circle-inactif">
          {merchand.merchantName
            ?.split(" ")
            .map((n) => n[0])
            .slice(0, 2)
            .join("")
            .toUpperCase()}
        </div>
          <div className="d-flex flex-column">
            <span className="title-name-merchend">
             {merchand.merchantName}
            </span>
            <span className="title-number-business">
              Dernière activité:{" "}
              {merchand.lastActivityDate
                ? new Date(merchand.lastActivityDate).toLocaleString("fr-FR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  })
                : "-"}
              </span>
          </div>
        </div>
          <div className="title-number d-flex align-items-center gap-1">
          <span className="statut">{FormatCurrency(merchand.totalRevenue) ||0}</span>
        </div>
        </div>
    )))}
  <PaginationCustom
  pageIndex={pagination.pageIndex}
  totalPages={totalPages}
  canPreviousPage={pagination.canPreviousPage}
  canNextPage={pagination.canNextPage}
  previousPage={pagination.previousPage}
  nextPage={pagination.nextPage}
  gotoPage={pagination.gotoPage}
/>
</CardBody>
</Card>
</Col>
</Row>
</div>
  </div>
);
  return (
    <React.Fragment>
     <div className="page-content">
        <Container fluid >
          <HeaderTable />
         <div className="title-merchend">Tous les marchands</div>
          <div className="title-number-business">Liste complète de tous les marchands de la plateforme</div>
            <div className="header-actions w-100 mb-3">
          <div className="col-6 p-0">
            <input
            type="text"
            placeholder="Rechercher un marchand ou un business"
            className="form-control search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
                    </div>
          <Button className="filtrer" onClick={() => openModal("merchent-filtrer")}>
            <img src={filter} alt="Filtrer" width={20} />
            Filtrer
          </Button>
          <Button className="filtrer" onClick={() => openModal("merchent-trier")}>
            <img src={trier} alt="Trier" width={20} />
            Trier
          </Button>
         <Dropdown menu={{ items: exportMenu }} trigger={["click"]}>
        <Button className="filtrer">
          Export <DownOutlined />
        </Button>
      </Dropdown>
  
        <button className="buttonNewColla btn btn-primary ms-auto " onClick={() => setIsModalOpenNewMerchent(true)}>Nouveau marchand</button>
        </div>
         <Row className="w-100 m-0">
        <Col className="w- p-0">
        <Card className="h-100 w-100" style={{ border: "1px solid #E3E3E3" }}>
        <CardBody className="p-0 ">
        {renderTabs}
        {isLoading ? (
  <div style={{ padding: "20px" }}>
    <Skeleton active paragraph={{ rows: 8 }} />
  </div>
) : (
  <TableContainerMin
    columns={columns}
    data={filteredMerchents}
    isGlobalFilter={false}
    customPageSize={10}
    className="custom-header-css"
    divClass="table-responsive"
    tableClass="table w-100 mb-0 no-column-borders"
    theadClass="custom-thead"
    SearchPlaceholder="Recherche..."
    HeaderTable={HeaderTable}
  />
)}
        {isLoading && !isError && (
          <div className="text-center"><Skeleton/> </div>
        )}
        {filteredMerchents && filteredMerchents.length === 0 && !isLoading && (
     <div
        style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "40px 0"
      }}
    >
  <img
    src={empty}
    alt="Liste vide"
    style={{ width: "150px" }}
  />
</div>
        )}
      </CardBody>
    </Card>
  </Col>
</Row>
  <Modal
    open={isModalOpen}
    onCancel={() => setIsModalOpen(false)}
    footer={null}
    width={270}
    style={{
      background:"#FFFFFF",
      position: "absolute",
      top: modalPosition.top,
      left: modalPosition.left,
      borderRadius: 10,
      border: "1px solid #DFDFDF",
      padding: 0,
      boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    }}
   bodyStyle={{ padding: "8px 1px" }}

    mask={false}
    closable={false}
  >
    <div
      style={{
        display: "flex",
        flexDirection: "column",
         alignItems: "flex-start",
        gap: "12px",
      }}
    >
      <a
      onClick={() => {
         handleDetail(selectedMerchant)
        setIsModalOpen(false);
      }}
      style={{ display: "flex", alignItems: "start", gap: "8px", cursor: "pointer" }}
    >
     <img src={vectorIcon} alt="Voir détails" style={{ width: 20, height: 20 }} />

      <span class="actions">Détails</span>
    </a>
    {/* {*<a
  onClick={() => {
    openDeleteConfirmModal(selectedMerchant?.id);
    setIsModalOpen(false);
  }}
  style={{ display: "flex", alignItems: "start", gap: "8px", cursor: "pointer" }}
>
  <DeleteOutlined />
  <span className="actions">Supprimer le marchand</span>
</a>*} */}

  </div>
  </Modal>
          {modalState.type === "edit" && (
            <AddEditDevForm
              modal={modalState.type === "edit"}
              setModal={setModalState}
              toggle={() => openModal("edit", modalState.data)}
              selectedMerchent={modalState.data}
              currentuser={currentuser}
            />
          )}
          {isLoading ? (
        <Skeleton
        />
      ) : (
        <DetailBusiness
          modal={modalState.type === "detail"}
          setModal={setModalState}
          toggle={() => openModal("detail", modalState.data)}
          selectedMerchent={modalState.data}
          currentuser={currentuser}
          isLoading={false}
        />
      )}
          {modalState.type === "complete" && (
            <CompleteCompanymerchent
              modal={modalState.type === "complete"}
              setModal={setModalState}
              toggle={() => openModal("complete", modalState.data)}
              selectedCompany={modalState.data}
              currentuser={currentuser}
            />
          )}
          {modalState.type === "delete" && (
            <DeleteModal
              isOpen={true}
              title={`le marchand ${modalState.data.merchentName}`}
              loading={isDeleting}
              onCancel={closeDeleteConfirmModal}
              onConfirm={() => handleDelete(modalState.data.merchentId)}
            />
          )}
          {modalState.type === "valid" && (
            <ManageMerchent
              modal={modalState.type === "valid"}
              setModal={setModalState}
              toggle={() => openModal("valid", modalState.data)}
              selectedMerchent={modalState.data}
              mode="validate"
            />
          )}
          {modalState.type === "disable" &&(
            <ManageMerchent
              modal={modalState.type === "disable"}
              setModal={setModalState}
              toggle={() => openModal("disable", modalState.data)}
              selectedMerchent={modalState.data}
              mode="disable"
            />
          )}
         {modalState.type === "rappel" && (
            <KycMerchent
              modal={true}
              setModal={setModalState}
              toggle={() => setModalState({ type: null })}
              selectedMerchent={modalState.data}
              mode={modalState.action}            
            />
            )}
           {modalState.type === "merchent-filtrer" && (
              <FiltrerMerchentModal
                isOpen={modalState.type === "merchent-filtrer"}
                toggle={() => openModal("merchent-filtrer", modalState.data)}
                onApply={handleApplyFilters}
              />
            )}
            {modalState.type === "merchent-trier" && (
            <TrierMerchentModal
              isOpen={modalState.type === "merchent-trier"}
              toggle={() => openModal("merchent-trier", modalState.data)}
              onApplySort={(order) => setSortOrder(order)}
            />
          )}
           <CreateNewMerchentModal
          visible={isModalOpenNewMerchant}
          onClose={() => setIsModalOpenNewMerchent(false)}
          /> 
        </Container>
      </div>
    </React.Fragment>
  );
};
export default Merchent;
